const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/inbox/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
const paramSchema = z.object({
  formId: z.number().optional(),
  removeImport: z.boolean().optional()
});
export const Route = createFileRoute('/(app)/org/$org/idea-management/inbox/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: paramSchema,
  staticData: {
    topNav: {
      title: 'ideaManagement.portal.title'
    }
  }
});